export default "__VITE_ASSET__8MyjXjAm__"